import { Card, Divider, Grid } from '@mui/material';
import React from 'react';
import CardDetail from './CardDetail';

function DetalletEnvio({ data }) {
  const objRemit = {
    city: data.city_from,
    street: data.street_from,
    exterior_number: data.exterior_number_from,
    interior_number: data.interior_number_from,
    colonia: data.colonia_from,
    zipcode: data.zipcode_from,
    name: data.name_from,
    email: data.email_from,
    phone: data.phone_from
  };
  const objDesti = {
    city: data.city_to,
    street: data.street_to,
    exterior_number: data.exterior_number_to,
    interior_number: data.interior_number_to,
    colonia: data.colonia_to,
    zipcode: data.zipcode_to,
    name: data.name_to,
    email: data.email_to,
    phone: data.phone_to
  };
  return (
    <Card sx={{ padding: '15px' }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <CardDetail envioDetalle={objRemit} persona="remitente" title="Remitente" />
        </Grid>

        <Grid item xs={12} md={6}>
          <CardDetail envioDetalle={objDesti} persona="destinatario" title="Destinatario" />
        </Grid>
      </Grid>
    </Card>
  );
}

export default DetalletEnvio;
